/**
 * @generated SignedSource<<28a7c5e24d7306c9341f70ebf6dd173c>>
 * @relayHash f7c37999427526615d924b19e5123c77
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f7c37999427526615d924b19e5123c77

import { ConcreteRequest } from 'relay-runtime';
export type BetterDocRejectionReason = "BETTER_DOC_CHOSE_CARE_PROVIDER_BEFOREHAND" | "PATIENT_REFUSES_TO_USE_BETTER_DOC";
export type Ch_confirmBetterDocRejectionInput = {
  betterDocRejectionReason: BetterDocRejectionReason;
  id: string;
};
export type chConfirmBetterDocRejectionMutation$variables = {
  input: Ch_confirmBetterDocRejectionInput;
};
export type chConfirmBetterDocRejectionMutation$data = {
  readonly confirmBetterDocRejection: {
    readonly ProgressNoteMutationOutput: {
      readonly progressNote: {
        readonly betterDoc: {
          readonly rejectionReason: BetterDocRejectionReason | null;
        } | null;
        readonly id: string;
        readonly updatedAt: string;
      };
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type chConfirmBetterDocRejectionMutation = {
  response: chConfirmBetterDocRejectionMutation$data;
  variables: chConfirmBetterDocRejectionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": "ProgressNoteMutationOutput",
  "args": null,
  "concreteType": "ch_ProgressNoteMutationOutput",
  "kind": "LinkedField",
  "name": "ch_ProgressNoteMutationOutput",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ch_ProgressNote",
      "kind": "LinkedField",
      "name": "progressNote",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ch_ProgressNoteBetterDoc",
          "kind": "LinkedField",
          "name": "betterDoc",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rejectionReason",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chConfirmBetterDocRejectionMutation",
    "selections": [
      {
        "alias": "confirmBetterDocRejection",
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_confirmBetterDocRejectionPayload",
        "kind": "LinkedField",
        "name": "ch_confirmBetterDocRejection",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chConfirmBetterDocRejectionMutation",
    "selections": [
      {
        "alias": "confirmBetterDocRejection",
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_confirmBetterDocRejectionPayload",
        "kind": "LinkedField",
        "name": "ch_confirmBetterDocRejection",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "f7c37999427526615d924b19e5123c77",
    "metadata": {},
    "name": "chConfirmBetterDocRejectionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "6a228ae2407b919d62d2a4dce964cb33";

export default node;
